/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';

import { OTPComp } from '../OTPForm';

export interface IEmailKYCProps {
  emailSent?: boolean;
  email?: string;
  onOTPSubmit?(data: any): void;
  emailKYCFields?: any;
  emailKYCLayout?: any;
  validatorConfig?: any;
  onEmailSubmit?(data: any): void;
  renderSubmitButton?(): void;
  resendOtpClick?(): void;
}
export const EmailKYC = (props: IEmailKYCProps) => {
  const {
    emailSent,
    email,
    onOTPSubmit,
    emailKYCFields,
    emailKYCLayout,
    validatorConfig,
    onEmailSubmit,
    renderSubmitButton,
    resendOtpClick,
  } = props;

  return (
    <TweetyWidget
      fields={emailKYCFields}
      layout={emailKYCLayout}
      validatorConfig={validatorConfig}
      onFormSubmit={onEmailSubmit}
      renderSubmitButton={renderSubmitButton}
    />
  );
};

EmailKYC.defaultProps = {
  emailKYCFields: [
    {
      type: 'email',
      compProps: {
        id: 'email',
        label: 'Email Address',
        required: true,
        placeholder: 'Enter email address',
        errorText: 'Email is required',
      },
    },
    {
      type: 'phoneNumber',
      compProps: {
        id: 'phoneNumber',
        label: 'Telephone',
        required: true,
        placeholder: 'Enter phone number',
        errorText: 'Phone number is required',
      },
    },
  ],
  emailKYCLayout: [['email'], ['phoneNumber']],
  validatorConfig: {
    ruleSets: [
      {
        fields: {
          email: [
            {
              type: 'isEmail',
              errorMessage: 'Please enter a valid email address',
            },
          ],
          phoneNumber: [
            {
              type: 'REQUIRED',
              errorMessage: 'Phone Number is required',
            },
            {
              type: 'MINLENGTH',
              minlength: 8,
              errorMessage: 'Minimum length of Phone Number should be 8',
            },
          ],
        },
      },
    ],
  },
};
